<template>
  <div>
    <div class="container-upload-svg" :style="{ minHeight: height + 'px' }">
      <div v-if="isLoading" class="loading-upload">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <div v-else-if="!svg || !svg.svgContent" class="placeholder-upload-svg">
        <v-tabs v-model="activeTab" class="upload-svg-tabs">
          <v-tab>Upload file icon (.svg)</v-tab>
          <v-tab>Write code</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <div class="placeholder-upload" @click="uploadFile">
              <div class="text-center">
                <v-icon>mdi-upload</v-icon>
                <p>Upload SVG here</p>
                <input
                  style="display: none"
                  class="hidden"
                  type="file"
                  ref="inputSvg"
                  accept=".svg,image/svg+xml"
                  @change="onChangeFile"
                />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="write-code-svg">
              <v-textarea
                v-model="svgText"
                outlined
                rows="8"
                hide-details
                placeholder="<svg>...</svg>"
                @input="errorMessage = ''"
              />
              <div v-if="errorMessage" class="error-text">{{ errorMessage }}</div>
              <v-btn text color="primary" class="mt-2 px-0" :disabled="!svgText.trim()" @click="onApplyPastedSvg">
                Add SVG
              </v-btn>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div v-else class="svg-upload">
        <div class="svg-upload-item" :style="{ height: heightPreview + 'px' }" v-html="svg.svgContent"></div>
        <div class="action-upload">
          <v-btn icon @click="isShowPreview = true">
            <v-icon size="20">mdi-eye</v-icon>
          </v-btn>
          <v-btn icon @click="onEditSvg">
            <v-icon size="20">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="removeUpload">
            <v-icon size="20">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>

      <v-dialog v-model="isShowPreview" max-width="900">
        <v-card>
          <div class="d-flex justify-center pa-6 svg-preview-dialog" v-html="svg && svg.svgContent"></div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="isShowEdit" max-width="700">
        <v-card>
          <v-card-title>Edit SVG code</v-card-title>
          <v-card-text>
            <v-textarea v-model="svgText" outlined rows="10" hide-details @input="errorMessage = ''" />
            <div v-if="errorMessage" class="error-text mt-1">{{ errorMessage }}</div>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn text @click="isShowEdit = false">Cancel</v-btn>
            <v-btn text color="primary" @click="onApplyPastedSvg">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import './upload-svg.scss';
export default {
  props: {
    subTitle: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'SVG',
    },
    svg: {
      type: Object,
      default: () => {},
    },
    itemSetData: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: '350',
    },
    maxSize: {
      // đơn vị: MB
      type: Number,
      default: 2,
    },
    heightPreview: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      isLoading: false,
      isShowPreview: false,
      isShowEdit: false,
      activeTab: 0,
      svgText: '',
      errorMessage: '',
    };
  },
  methods: {
    uploadFile() {
      this.$refs.inputSvg.click();
    },
    async onChangeFile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const isSvg = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');
      if (!isSvg) {
        this.$store.dispatch('setMessage', { color: 'red', dialog: true, content: 'File must be an SVG!' });
        e.target.value = '';
        return;
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$store.dispatch('setMessage', {
          color: 'red',
          dialog: true,
          content: `File must be less than ${this.maxSize}MB!`,
        });
        e.target.value = '';
        return;
      }

      this.isLoading = true;
      try {
        const content = await this.readFileAsText(file);
        if (!this.isValidSvg(content)) {
          this.$store.dispatch('setMessage', { color: 'red', dialog: true, content: 'Invalid SVG content!' });
          return;
        }
        this.applySvg(content, file.name);
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
        e.target.value = '';
      }
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    isValidSvg(content) {
      if (!content) return false;
      return /<svg[\s\S]*<\/svg>/i.test(content.trim());
    },
    onApplyPastedSvg() {
      const content = (this.svgText || '').trim();
      if (!content) return;
      if (!this.isValidSvg(content)) {
        this.errorMessage = 'Invalid SVG code. Please paste a valid <svg>...</svg> markup.';
        return;
      }
      this.applySvg(content, 'svg-code');
      this.isShowEdit = false;
    },
    applySvg(content, name) {
      const obj = {
        svgContent: content.trim(),
        alt: name || 'svg',
        _id: this.objectId(),
      };
      this.$emit('callback', obj, this.itemSetData, 'svg');
      this.resetForm();
    },
    onEditSvg() {
      this.svgText = this.svg.svgContent;
      this.errorMessage = '';
      this.isShowEdit = true;
    },
    removeUpload() {
      this.$emit('callbackDelete', this.itemSetData, 'svg');
      this.resetForm();
    },
    resetForm() {
      this.svgText = '';
      this.errorMessage = '';
      this.activeTab = 0;
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },
    hex(value) {
      return Math.floor(value).toString(16);
    },
  },
};
</script>

<style scoped lang="scss">
.error-text {
  color: #e53935;
  font-size: 13px;
}
.upload-svg-tabs {
  ::v-deep .v-tab {
    font-size: 14px;
    text-transform: none;
  }
}
</style>
